import { IonContent, IonPage } from '@ionic/react';
import React, { useEffect, useState } from 'react';

import { Padding, Spacer } from '@/components/common';
import {
  BackgroundShapes,
  Faqs,
  Footer,
  Hero,
  HowItWorks,
  LandingPageLogo,
  Metrics,
  Pricing,
  Testimonials,
  TrustedBy
} from '@/components/landingPage';

import './LandingPage.css';

const LandingPage: React.FC = () => {
  const [anchor, setAnchor] = useState<string>('');

  useEffect(() => {
    setAnchor(window.location.hash);

    const onHashChange = () => {
      setAnchor(window.location.hash);
    };

    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  useEffect(() => {
    if (anchor) {
      const anchorElement = document.getElementById(anchor.slice(1));
      if (anchorElement) {
        setTimeout(() => {
          anchorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 742);
      }
    }
  }, [anchor]);

  return (
    <IonPage className="landing-page">
      <IonContent>
        <BackgroundShapes />
        <Padding customMaxWidth={624}>
          <LandingPageLogo fixed={!!anchor} />
          <Hero />
          <Spacer top={98} />
          <TrustedBy />
          <HowItWorks />
          <Metrics />
          <Testimonials />
          <Pricing />
          <Faqs />
          <Footer />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default LandingPage;
